"use client";

import { Text } from "@pamperedchef/design-system";
import type { HTMLAttributes } from "react";
import { RichText, type RichTextHeadingTag } from "../RichText";
import * as styles from "./FeaturedText.module.scss";

export interface FeaturedTextProps extends HTMLAttributes<HTMLDivElement> {
	alignment?: "center" | "left" | "right" | "inherit";
	eyebrow?: string;
	headline: string;
	styledAs?: "display-lg" | "display-md" | "display-sm";
	theme?: "circle" | "star";
	headingTag?: RichTextHeadingTag;
}

function joinClassNames(...classNames: Array<string | undefined>): string {
	return classNames.filter(Boolean).join(" ");
}

export function FeaturedText({
	alignment = "center",
	eyebrow,
	headline,
	styledAs,
	theme,
	headingTag = "h2",
	className,
	...props
}: FeaturedTextProps) {
	const headlineHtml = headline
		.replace(/<p(\s[^>]*)?>/gi, "<span>")
		.replace(/<\/p>/gi, "</span>");

	return (
		<div
			{...props}
			className={joinClassNames(
				styles["featured-text"],
				theme ? styles[theme] : undefined,
				styles[`featured-text--${alignment}`],
				className
			)}
		>
			{eyebrow ? (
				<Text
					tag="span"
					styledAs="eyebrow-1"
					className={styles["eyebrow"]}
				>
					{eyebrow}
				</Text>
			) : null}

			<RichText
				className={joinClassNames(
					styles["headline"],
					styledAs ?? "display-lg"
				)}
				tag={headingTag}
				content={headlineHtml}
				alignment={alignment}
			/>
		</div>
	);
}
